<template>
  <div class="app-container remove-circle">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        @current-change="currentChange"
        @refresh-change="refreshChange"
        @size-change="sizeChange"
        @search-change="searchChange"
        @search-reset="searchReset"
      >
        <template slot="circleName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toCircleDetail(scope.row.circleId);"
              class="circle-list-container-button">
            {{scope.row.circleName}}</a>
        </template>

        <template slot="search">
          <el-form-item label="状态">
            <el-select
              size="small"
              v-model="listQuery.requestStatus"
              >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="text"
            v-if="permissions.remove_circle_approve && scope.row.requestStatus === 0"
            size="mini"
            @click="handleApprove(scope.row,scope.index)"
          >通过</el-button>
          <el-button
            type="text"
            v-if="permissions.remove_circle_reject && scope.row.requestStatus === 0"
            size="mini"
            @click="handleReject(scope.row,scope.index)"
          >拒绝</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>
<script>
import { tableOption, statusOptions } from '@/const/crud/post/removeCircle'
import { fetchRequestList, approveRequest, rejectRequest } from '@/api/post/circleRequest'
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      tableData: [],
      tableLoading: false,
      listQuery: {
        current: 1,
        size: 20,
        sortField: 'requested_time',
        sortPolicy: 'desc',
        requestType: 0,
        requestStatus: '',
      },
      tableOption: tableOption,
      statusOptions: statusOptions
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  methods: {
    getParams () {
      return this.listQuery
    },
    getList () {
      this.tableLoading = true
      fetchRequestList(this.listQuery).then(response => {
        this.tableData = this.formatData(response.data.data.records)
        this.page.total = response.data.data.total
        this.tableLoading = false
      }).catch(error => {
        this.$message({
          message: '获取解散圈子申请列表失败',
          type: 'error'
        })
        this.tableLoading = false
      })
    },
    formatData (records) {
      if (Array.isArray(records)) {
        records.forEach(x => {
          x.statusText = this.statusOptions[x.requestStatus].label
          x.publicText = x.isPublic ? '是' : '否'
        })
      }
      return records
    },
    handleApprove (row, index) {
      this.tableLoading = true
      this.$confirm('是否确认通过该解散申请?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return approveRequest(row.id);
      }).then(response => {
        this.$message({
          message: '通过成功',
          type: 'success'
        })
        if (response.data.data) {
          row.requestStatus = 1
          row.statusText = this.statusOptions[row.requestStatus].label
        }
        this.tableLoading = false
      }).catch(error => {
        this.tableLoading = false
      })
    },
    handleReject (row, index) {
      this.tableLoading = true
      this.$confirm('是否确认拒绝该解散申请?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return rejectRequest(row.id);
      }).then(response => {
        this.$message({
          message: '拒绝成功',
          type: 'success'
        })
        if (response.data.data) {
          row.requestStatus = 2
          row.statusText = this.statusOptions[row.requestStatus].label
        }
        this.tableLoading = false
      }).catch(error => {
        this.tableLoading = false
      })
    },
    toCircleDetail(circleId) {
      // 点击圈子名称，链接转到该圈子的详情页面
      this.$router.push({
        path: "/post/circle/detail/" + circleId,
      })
    },
    searchReset () {
      this.listQuery.requestStatus = ''
      this.searchChange({})
    },
    searchChange (params) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.listQuery.circleName = params.circleName
      this.getList()
    },
    currentChange (val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange (val) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    refreshChange () {
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>

.circle-list {
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>